import { V_FORM_ENUM } from '@/CommonDP/VForm/utils';

export const schema = {
  group: V_FORM_ENUM.custom,
  type: 'jy-html',
  icon: 'html-text',
  label: '富文本模版',
  formItemFlag: true,
  component: require('./index.vue').default,
  props() {
    return {
      contentKey: () => import('./setting.vue')
    };
  },
  events() {
    return { onLoad: ['html'] };
  },
  options: {
    name: '',
    label: '详情',
    labelHidden: false,
    labelWidth: '',
    position: '',
    labelWrap: false, // 自动换行
    labelAlign: '',
    columnWidth: '200px',
    // -----
    maxHeight: "",
    contentKey: '',
    onLoad: ""
  }
};
